import { render, staticRenderFns } from "./admin_group.vue?vue&type=template&id=e2e4f47a&scoped=true&"
import script from "./admin_group.vue?vue&type=script&lang=js&"
export * from "./admin_group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e4f47a",
  null
  
)

export default component.exports